/* eslint-disable new-cap */
import React from 'react'
import { useHookstate, type State } from '@hookstate/core'
import { Card, CardHeader, IconButton } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import ManagementInvolvedFilters from '../ManagementQualifiersFilters'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ChartsDrugs from './components/ChartsDrugs'
import useManagementQualifiersDrugsState from '~/features/Management/stores/ManagementQualifiersDrugsState'
import { FilterState, IListDispatchTab, InvolvedFilter } from '~/features/Management/interfaces'

interface IDrugsChartProps {
  readonly expandFilterSearch: State<boolean>;
  readonly valueTab?: IListDispatchTab;
  readonly filters: State<FilterState>;
  readonly setFilters: (filters: InvolvedFilter) => void;
  readonly searched: boolean;
  readonly setSearched: (value: boolean) => void;
}

export default function DrugsChart({
  expandFilterSearch,
  valueTab,
  filters,
  setFilters,
  searched,
  setSearched,
}: IDrugsChartProps) {
  const { loadingCharts } = useManagementQualifiersDrugsState()
  const labelButton = useHookstate<string>('Search')
  const { translate } = useLang()

  return (
    <Card
      sx={{
        boxShadow: 4,
        paddingBottom: 2,
        height: expandFilterSearch.value ? 'auto' : 50,
      }}
    >
      <CardHeader
        title={`${translate('Filters')}`}
        avatar={
          <IconButton
            onClick={() => {
              expandFilterSearch.set((item) => !item)
            }}
            sx={{
              display: 'flex',
              justifyContent: 'end',
              marginRight: 1,
            }}
          >
            {expandFilterSearch.value ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        titleTypographyProps={{ fontWeight: 'bold', fontSize: 18 }}
      />
      <ManagementInvolvedFilters
        hidden={expandFilterSearch.get()}
        labelButton={labelButton}
        periodFilter
        typeVehicleFilter
        destinationFinalFilter
        vehicleCiscunstanceFilter
        valueTab={valueTab}
        clearFilters={() => {
          setSearched(false)
        }}
        searchButton={() => {
          setSearched(true)
        }}
        filters={filters}
        setFilters={setFilters}
      />
      {!loadingCharts.get() && searched && (
        <ChartsDrugs expandFilterSearch={expandFilterSearch.get()} />
      )}
    </Card>
  )
}
